import { render } from "./ViewChallengePractice.vue?vue&type=template&id=21ff3efd&scoped=true"
import script from "./ViewChallengePractice.vue?vue&type=script&lang=js"
export * from "./ViewChallengePractice.vue?vue&type=script&lang=js"

import "@/css/views/view-challenge-practice.css?vue&type=style&index=0&id=21ff3efd&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ff3efd"]])

export default __exports__